import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/components/ui/resizable";
import { Sidebar } from "./Sidebar";
import { SqlEditor } from "./SqlEditor";
import { ResultsTable } from "./ResultsTable";
import { CircleStackIcon } from "@heroicons/react/24/outline";
import { ThemeToggle } from "@/components/theme-toggle";

export function DashboardLayout() {
  return (
    <div className="h-screen w-screen bg-background text-foreground flex flex-col overflow-hidden">
      <header className="h-12 border-b border-border flex items-center justify-between px-4 bg-card/80 backdrop-blur-sm shrink-0">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-lg bg-primary/10 flex items-center justify-center">
            <CircleStackIcon className="w-4 h-4 text-primary" />
          </div>
          <span className="text-sm font-semibold tracking-tight">
            PG Playground
          </span>
        </div>
        <ThemeToggle />
      </header>

      <div className="flex-1 overflow-hidden">
        <ResizablePanelGroup orientation="horizontal">
          <ResizablePanel
            defaultSize={300}
            maxSize={500}
            minSize={200}
            className="flex flex-col overflow-hidden"
          >
            <Sidebar />
          </ResizablePanel>

          <ResizableHandle className="w-px bg-border hover:bg-primary/40 transition-colors flex items-center justify-center group outline-none data-[resize-handle-active]:bg-primary/40">
            <div className="h-6 w-0.5 rounded-full bg-transparent group-hover:bg-primary/50 transition-colors" />
          </ResizableHandle>

          <ResizablePanel minSize={50} className="overflow-hidden">
            <ResizablePanelGroup orientation="vertical">
              <ResizablePanel
                defaultSize={60}
                minSize={30}
                className="flex flex-col overflow-hidden"
              >
                <SqlEditor />
              </ResizablePanel>

              <ResizableHandle className="h-px bg-border hover:bg-primary/40 transition-colors flex items-center justify-center group outline-none data-[resize-handle-active]:bg-primary/40">
                <div className="w-6 h-0.5 rounded-full bg-transparent group-hover:bg-primary/50 transition-colors" />
              </ResizableHandle>

              <ResizablePanel
                defaultSize={40}
                minSize={20}
                collapsible={true}
                className="flex flex-col overflow-hidden"
              >
                <ResultsTable />
              </ResizablePanel>
            </ResizablePanelGroup>
          </ResizablePanel>
        </ResizablePanelGroup>
      </div>
    </div>
  );
}
